import React, { useEffect, useState, createContext, useContext } from "react";
import { useDispatch } from "react-redux";
import { getAuthToken, removeAuthToken, UserAPI } from "../components/api";
import { getUser, logoutSuccess } from "../redux/modules/userSlice";
import { persistor } from "../redux";

const SessionContext = createContext({
  sessionReady: false,
});

export function useSession() {
  return useContext(SessionContext);
}

/**
 * After rehydrate: load roles from GET /user/me (DB source of truth).
 * Blocks private routes until sessionReady is true.
 * Uses local state so a persisted sessionReady=true cannot flash admin UI.
 */
function AuthBootstrap({ children }) {
  const dispatch = useDispatch();
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = function () {
      const token = getAuthToken();
      if (!token) {
        if (!cancelled) {
          dispatch(logoutSuccess());
          setSessionReady(true);
        }
        return;
      }

      UserAPI.me()
        .then(function (response) {
          if (cancelled) {
            return;
          }
          if (response && response.success && response.data) {
            dispatch(getUser(response.data));
            setSessionReady(true);
          } else {
            removeAuthToken();
            persistor.purge().then(
              function () {
                dispatch(logoutSuccess());
                setSessionReady(true);
              },
              function () {
                dispatch(logoutSuccess());
                setSessionReady(true);
              }
            );
          }
        })
        .catch(function () {
          if (cancelled) {
            return;
          }
          removeAuthToken();
          persistor.purge().then(
            function () {
              dispatch(logoutSuccess());
              setSessionReady(true);
            },
            function () {
              dispatch(logoutSuccess());
              setSessionReady(true);
            }
          );
        });
    };

    bootstrap();
    return function () {
      cancelled = true;
    };
  }, [dispatch]);

  if (!sessionReady) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "40vh" }}
      >
        Loading...
      </div>
    );
  }

  return (
    <SessionContext.Provider value={{ sessionReady: true }}>
      {children}
    </SessionContext.Provider>
  );
}

export default AuthBootstrap;
